// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__8C3Lv","container":"Skills_container__lfBF4","link":"Skills_link__NO4l4","topLi":"Skills_topLi__xesP5","topLi2":"Skills_topLi2__pyvj1"};